import React from 'react';
import NoviSadKrozVreme from './NoviSadKrozVreme';

function App() {
  return <NoviSadKrozVreme />;
}

export default App;
